<mat-card class="daxa-card error-card mb-25 pt-0 border-radius bg-white border-none d-block text-center">
  <mat-card-content>
    <img ngSrc="images/error404.png" alt="error-image" width="700" height="554" />
    <h3 style="margin-top: 20px;">
      Página no encontrada!
    </h3>
    <a routerLink="/">
      Volver
    </a>
  </mat-card-content>
</mat-card>
